import { useQuery } from "@tanstack/react-query";
import axiosInstanceNode from "@/api/axiosInstanceNode";
import { useMainStore } from "@/stores";

export const TRIAL_USAGE_QUERY_KEY = ["trial-usage"];

/**
 * Trial usage vs. limits ({ trial, limits, used }) from the server. Only fetched for trial
 * accounts; paid users get undefined and see no counters. Mutations refresh it (App.jsx).
 */
export function useTrialUsage() {
  const isTrial = useMainStore((state) => state.user?.plan === "trial");
  const { data } = useQuery({
    queryKey: TRIAL_USAGE_QUERY_KEY,
    queryFn: async () => (await axiosInstanceNode.get("/auth/trial-usage")).data,
    enabled: isTrial === true,
    staleTime: 30_000,
    meta: { silentError: true },
  });
  return data?.trial ? data : undefined;
}
